import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "fw-semibold mb-8" }
const _hoisted_6 = { class: "fw-bold m-5" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "card-body d-flex justify-content-center" }
const _hoisted_10 = {
  class: "nav nav-tabs bg-white border-0 rounded-0 max-selection-width",
  role: "tablist"
}
const _hoisted_11 = ["aria-selected", "onClick"]
const _hoisted_12 = { class: "row d-flex justify-content-center" }
const _hoisted_13 = { class: "col-12 col-md-6 max-selection-width" }
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "col-12 col-md-6 max-selection-width" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-12 col-sm-6" }
const _hoisted_19 = { class: "card-body" }
const _hoisted_20 = {
  key: 0,
  class: "row justify-content-left p-3"
}
const _hoisted_21 = { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }
const _hoisted_22 = { class: "card-body shift-card-body" }
const _hoisted_23 = { class: "align-items-center" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "product-details-content" }
const _hoisted_26 = { class: "info ps-0 list-unstyled d-inline-block" }
const _hoisted_27 = { class: "text-para fs-md-15 fs-xxxl-16" }
const _hoisted_28 = { class: "overView-value" }
const _hoisted_29 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_30 = { class: "overView-value" }
const _hoisted_31 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_32 = { class: "overView-value" }
const _hoisted_33 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_34 = { class: "overView-value" }
const _hoisted_35 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_36 = { class: "overView-value" }
const _hoisted_37 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_38 = { class: "overView-value" }
const _hoisted_39 = { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }
const _hoisted_40 = { class: "card-body shift-card-body" }
const _hoisted_41 = { class: "align-items-center" }
const _hoisted_42 = { class: "" }
const _hoisted_43 = { class: "product-details-content" }
const _hoisted_44 = { class: "info ps-0 list-unstyled d-inline-block" }
const _hoisted_45 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_46 = { class: "overView-value" }
const _hoisted_47 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_48 = { class: "overView-value" }
const _hoisted_49 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_50 = { class: "overView-value" }
const _hoisted_51 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_52 = { class: "overView-value" }
const _hoisted_53 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_54 = { class: "overView-value" }
const _hoisted_55 = { class: "p-15" }
const _hoisted_56 = { class: "col-12 col-sm-6" }
const _hoisted_57 = {
  key: 0,
  class: "col-12"
}
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "card border-0 rounded-0 bg-white" }
const _hoisted_60 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_61 = { class: "d-sm-flex align-items-center justify-content-between" }
const _hoisted_62 = { class: "col-12" }
const _hoisted_63 = { class: "card border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_64 = { class: "card-body" }
const _hoisted_65 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  role: "tablist"
}
const _hoisted_66 = {
  class: "nav-item",
  role: "tablist"
}
const _hoisted_67 = ["aria-selected"]
const _hoisted_68 = {
  class: "nav-item",
  role: "tablist"
}
const _hoisted_69 = ["aria-selected"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EventCountGraph = _resolveComponent("EventCountGraph")!
  const _component_EventFrequencyStackedColumn = _resolveComponent("EventFrequencyStackedColumn")!
  const _component_CompanyTimelineGraphVue = _resolveComponent("CompanyTimelineGraphVue")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createElementVNode("h4", _hoisted_5, [
            _cache[6] || (_cache[6] = _createTextVNode(" Instalace: ", -1)),
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.route.params.appuuid), 1),
            (_ctx.detailData.appuuidAlias != null && _ctx.detailData.appuuidAlias.length > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                  _cache[5] || (_cache[5] = _createTextVNode(" Název: ", -1)),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.detailData.appuuidAlias), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("ul", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detailData.products, (item, index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.productName,
                  class: "nav-item",
                  role: "tablist"
                }, [
                  _createElementVNode("button", {
                    class: _normalizeClass(['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (index==_ctx.selectedProductIndex)?true:false }]),
                    role: "button",
                    "aria-selected": (index==_ctx.selectedProductIndex)?true:false,
                    onClick: ($event: any) => (_ctx.selectProduct(index))
                  }, _toDisplayString(item.productName), 11, _hoisted_11)
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[8] || (_cache[8] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10 mt-2" }, "Zobrazení", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.displayOption) = $event)),
                class: "project-select form-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10"
              }, [
                _cache[7] || (_cache[7] = _createElementVNode("option", { value: "event" }, "Události", -1)),
                _createElementVNode("option", {
                  value: "table",
                  disabled: _ctx.detailData.companyTimeLineGraph != undefined && _ctx.detailData.companyTimeLineGraph.length == 0
                }, "Firmy", 8, _hoisted_14)
              ], 512), [
                [_vModelSelect, _ctx.displayOption]
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _cache[9] || (_cache[9] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10 mt-2 mr-2" }, "Výběr firmy ", -1)),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedCompany) = $event)),
                class: "project-select form-select shadow-none fw-semibold rounded-1 mt-10 mt-sm-0 ms-sm-10",
                disabled: _ctx.displayOption!='table'
              }, [
                (_ctx.detailData.products[_ctx.selectedProductIndex] != undefined)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.detailData.products[_ctx.selectedProductIndex].companyNames, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option,
                        value: option.value
                      }, _toDisplayString(option.text), 9, _hoisted_17))
                    }), 128))
                  : _createCommentVNode("", true)
              ], 8, _hoisted_16), [
                [_vModelSelect, _ctx.selectedCompany]
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            (_ctx.detailData.products.length>0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("ul", _hoisted_26, [
                              _createElementVNode("li", _hoisted_27, [
                                _cache[10] || (_cache[10] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Aktuální verze: ", -1)),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].currentProductVersion), 1)
                              ]),
                              _createElementVNode("li", _hoisted_29, [
                                _cache[11] || (_cache[11] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Datum instalace aktuální verze: ", -1)),
                                _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].currentProductDate), 1)
                              ]),
                              _createElementVNode("li", _hoisted_31, [
                                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Licence: ", -1)),
                                _createElementVNode("span", _hoisted_32, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].currentProductLicense), 1)
                              ]),
                              _createElementVNode("li", _hoisted_33, [
                                _cache[13] || (_cache[13] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Počet spravovaných firem: ", -1)),
                                _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].latestCompanyCount), 1)
                              ]),
                              _createElementVNode("li", _hoisted_35, [
                                _cache[14] || (_cache[14] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Počet modulů: ", -1)),
                                _createElementVNode("span", _hoisted_36, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].moduleCount), 1)
                              ]),
                              _createElementVNode("li", _hoisted_37, [
                                _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Počet událostí: ", -1)),
                                _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].eventCount), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _createElementVNode("div", _hoisted_40, [
                      _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("div", _hoisted_42, [
                          _createElementVNode("div", _hoisted_43, [
                            _createElementVNode("ul", _hoisted_44, [
                              _createElementVNode("li", _hoisted_45, [
                                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Předchozí verze: ", -1)),
                                _createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].previousProductVersion), 1)
                              ]),
                              _createElementVNode("li", _hoisted_47, [
                                _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Datum instalace předchozí verze: ", -1)),
                                _createElementVNode("span", _hoisted_48, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].previousProductDate), 1)
                              ]),
                              _createElementVNode("li", _hoisted_49, [
                                _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Lincence předchozí verze: ", -1)),
                                _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.detailData.products[_ctx.selectedProductIndex].previousProductLicense), 1)
                              ]),
                              (_ctx.detailData.products[_ctx.selectedProductIndex].companyEvents.find((item)=> item.firuuid == _ctx.selectedCompany) != undefined && _ctx.displayOption == 'table')
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createElementVNode("li", _hoisted_51, [
                                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Typ účetnictví: ", -1)),
                                      _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.getUctType(_ctx.detailData.products[_ctx.selectedProductIndex].companyEvents.find((item)=> item.firuuid == _ctx.selectedCompany))), 1)
                                    ]),
                                    _createElementVNode("li", _hoisted_53, [
                                      _cache[20] || (_cache[20] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Typ organizace: ", -1)),
                                      _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.getOrgType(_ctx.detailData.products[_ctx.selectedProductIndex].companyEvents.find((item)=> item.firuuid == _ctx.selectedCompany))), 1)
                                    ])
                                  ], 64))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("span", _hoisted_55, [
              _createElementVNode("button", {
                class: "default-btn position-relative transition border-0 fw-medium text-white mb-3 pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redirectToInfo(_ctx.route.params.appuuid)))
              }, _toDisplayString(_ctx.infoButtonText), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_56, [
          _createVNode(_component_EventCountGraph, {
            detailData: _ctx.detailData.products[_ctx.selectedProductIndex],
            dataType: _ctx.displayOption,
            selectedCompany: _ctx.selectedCompany
          }, null, 8, ["detailData", "dataType", "selectedCompany"])
        ]),
        (_ctx.detailData.eventFrequencyStackedColumnData != undefined && _ctx.displayOption == 'event')
          ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
              _createVNode(_component_EventFrequencyStackedColumn, {
                detailData: _ctx.detailData.eventFrequencyStackedColumnData[_ctx.detailData.eventFrequencyStackedColumnData.findIndex(item => item.productName == _ctx.detailData.products[_ctx.selectedProductIndex].productName)].data 
              }, null, 8, ["detailData"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.detailData.companyTimeLineGraph != undefined && _ctx.selectedCompany != undefined && _ctx.displayOption == 'table')
          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
              _createVNode(_component_CompanyTimelineGraphVue, {
                detailData: _ctx.detailData.companyTimeLineGraph.find(item => item.firuuid == _ctx.selectedCompany).data
              }, null, 8, ["detailData"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_59, [
      _createElementVNode("div", _hoisted_60, [
        _createElementVNode("div", _hoisted_61, [
          _createElementVNode("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createElementVNode("ul", _hoisted_65, [
                  _createElementVNode("li", _hoisted_66, [
                    _createElementVNode("button", {
                      class: _normalizeClass(['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (_ctx.selectedHistoryType == 'event')?true:false }]),
                      role: "button",
                      "aria-selected": (_ctx.selectedHistoryType == 'version')?true:false,
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectHistory('event')))
                    }, "Historie událostí ", 10, _hoisted_67)
                  ]),
                  _createElementVNode("li", _hoisted_68, [
                    _createElementVNode("button", {
                      class: _normalizeClass(['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (_ctx.selectedHistoryType == 'version')?true:false }]),
                      role: "button",
                      "aria-selected": (_ctx.selectedHistoryType == 'version')?true:false,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectHistory('version')))
                    }, "Historie verzí ", 10, _hoisted_69)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}